import pImg1 from '../images/testimonial/1.png'
import pImg2 from '../images/testimonial/2.png'
import pImg3 from '../images/testimonial/3.png'
import pImg4 from '../images/testimonial/4.png'
import pImg5 from '../images/testimonial/5.png'
import pImg6 from '../images/project/d.png'
import pImg7 from '../images/project/7.png'
import pImg8 from '../images/project/8.png'
import icon1 from '../images/icon/pro-icon01.png'
import icon2 from '../images/icon/pro-icon02.png'
import icon3 from '../images/icon/pro-icon03.png'

const Project = [
    {
        Id: '1',
        pImg: pImg1,
        videoId: 'nbso3NVz3p8',
        title: 'Odoo ERP setup for retail growth',
        slug: 'odoo-erp-setup-for-retail-growth',
        rnumber: '315',
        rtext: 'Process improvement',
        tnumber: '218',
        ttext: 'Hours saved yearly',
        snumber: '522',
        stext: 'Manual work reduced',
        description: 'Complete Odoo ERP setup for retail, boosting sales, inventory control, and daily operations.',
        fullDescription: 'Complete Odoo ERP setup for retail businesses enables streamlined operations from inventory management to sales tracking. This implementation connects all aspects of your retail business into one unified platform, ensuring accurate stock levels, faster checkout processes, and comprehensive sales analytics.',
        detailedContent: 'Implementing Odoo ERP for retail operations transforms how you manage inventory, sales, and customer relationships. Our solution provides real-time inventory visibility, automated reordering, and seamless point-of-sale integration. This eliminates manual data entry, reduces stock-outs, and improves overall operational efficiency.',
        client: 'Retail Chain Store',
        services: 'Odoo ERP Implementation',
        completedDate: '15-10-2024',
        location: 'Mumbai, India',
        requirements: [
            'Real-time inventory tracking across multiple stores',
            'Integrated point-of-sale system',
            'Automated stock replenishment',
            'Customer loyalty program integration',
            'Sales analytics and reporting',
            'Multi-warehouse management'
        ],
        solution: 'We deployed Odoo ERP with complete retail module configuration, integrated POS terminals, and established automated inventory sync across 12 retail locations. Our team trained 50+ staff members on the platform.',
        results: 'The client achieved 315% improvement in process efficiency, saved 218 hours yearly in manual operations, and reduced manual work by 522%. Stock accuracy improved to 99.8% and customer checkout time reduced by 40%.'
    },
    {
        Id: '2',
        pImg: pImg2,
        videoId: 'nbso3NVz3p8',
        title: 'Shopify with Odoo auto sync',
        slug: 'shopify-with-odoo-auto-sync',
        rnumber: '310',
        rtext: 'Faster order flow',
        tnumber: '121',
        ttext: 'Team hours saved',
        snumber: '410',
        stext: 'Stock errors reduced',
        description: 'Shopify integrated with Odoo for auto orders, stock sync, and smooth e-commerce flow.',
        fullDescription: 'Seamless integration between Shopify storefront and Odoo ERP ensures real-time order synchronization, automatic inventory updates, and unified customer data. Orders placed on Shopify automatically flow into Odoo for processing and fulfillment.',
        detailedContent: 'This integration eliminates manual order entry and ensures inventory accuracy across channels. When customers purchase on Shopify, the order instantly appears in Odoo with proper accounting entries. Inventory updates in Odoo automatically reflect on Shopify to prevent overselling.',
        client: 'E-commerce Fashion Brand',
        services: 'Shopify-Odoo Integration',
        completedDate: '22-08-2024',
        location: 'Delhi, India',
        requirements: [
            'Real-time order synchronization from Shopify to Odoo',
            'Automatic inventory sync between platforms',
            'Customer data consolidation',
            'Automated payment reconciliation',
            'Multi-channel order management',
            'Fulfillment automation'
        ],
        solution: 'We built custom connectors using Shopify API and Odoo webhooks to ensure bidirectional sync. Orders sync within 30 seconds, inventory updates in real-time, and customer records merge automatically.',
        results: 'Order processing time reduced by 310%, team saves 121 hours monthly, and stock errors decreased by 410%. The client now handles 5x order volume with same resources.'
    },
    {
        Id: '3',
        pImg: pImg3,
        videoId: 'nbso3NVz3p8',
        title: 'Odoo MRP for manufacturing unit',
        slug: 'odoo-mrp-for-manufacturing-unit',
        rnumber: '418',
        rtext: 'Production boost',
        tnumber: '185',
        ttext: 'Tasks automated',
        snumber: '480',
        stext: 'Tracking improved',
        description: 'Odoo MRP system enabled better planning, routing, and quality control for factories.',
        fullDescription: 'Manufacturing Resource Planning (MRP) in Odoo provides comprehensive production management from bill of materials to work orders and quality control. The system optimizes production schedules, manages resources efficiently, and tracks every manufacturing stage.',
        detailedContent: 'Our Odoo MRP implementation transforms manufacturing operations through automated work order generation, real-time production tracking, and quality assurance workflows. The system maintains optimal stock levels of raw materials and manages production bottlenecks intelligently.',
        client: 'Industrial Manufacturing Company',
        services: 'Odoo MRP Implementation',
        completedDate: '10-07-2024',
        location: 'Bangalore, India',
        requirements: [
            'Bill of Materials (BoM) management',
            'Work order automation',
            'Production routing and scheduling',
            'Quality control checkpoints',
            'Raw material tracking',
            'Machine capacity planning'
        ],
        solution: 'We configured Odoo MRP with 50+ BoMs, set up 30 work stations with routing, implemented quality gates, and connected IoT sensors for real-time tracking.',
        results: 'Production increased by 418%, reduced manual planning tasks by 185 hours monthly, improved tracking visibility by 480%, and reduced production cycle time by 35%.'
    },
    {
        Id: '4',
        pImg: pImg4,
        videoId: 'nbso3NVz3p8',
        title: 'Custom Odoo accounting module',
        slug: 'custom-odoo-accounting-module',
        rnumber: '588',
        rtext: 'Finance automation',
        tnumber: '355',
        ttext: 'Reconciliation time saved',
        snumber: '547',
        stext: 'Entry errors reduced',
        description: 'Custom Odoo module automated journal entries and financial reporting for businesses.',
        fullDescription: 'A custom Odoo accounting module that automates journal entries, reconciliation, and financial reporting. The system intelligently maps transactions, validates entries, and generates accurate financial statements.',
        detailedContent: 'Our custom module eliminates manual journal entry errors through intelligent automation. It validates every transaction against predefined rules, auto-generates complex entries, and provides real-time reconciliation dashboards.',
        client: 'Multi-entity Financial Services Group',
        services: 'Custom Accounting Module Development',
        completedDate: '05-09-2024',
        location: 'Hyderabad, India',
        requirements: [
            'Automated journal entry generation',
            'Multi-company consolidation',
            'Bank reconciliation automation',
            'Tax compliance reporting',
            'Custom financial statements',
            'Audit trail tracking'
        ],
        solution: 'We built a custom Python module with 1500+ lines of code, integrated bank APIs for automatic transactions, created custom reconciliation rules, and set up automated reporting.',
        results: 'Finance automation increased by 588%, reconciliation time reduced by 355 hours monthly, entry errors decreased by 547%, and month-end close time reduced from 5 days to 1 day.'
    },
    {
        Id: '5',
        pImg: pImg5,
        videoId: 'nbso3NVz3p8',
        icon: icon1,
        title: 'Odoo mobile app (React Native)',
        slug: 'odoo-mobile-app-react-native',
        rnumber: '450',
        rtext: 'Productivity boost',
        tnumber: '200',
        ttext: 'Hours saved yearly',
        snumber: '380',
        stext: 'Data errors reduced',
        rtext1: 'Mobile',
        rtext2: 'API',
        rtext3: 'UX',
        description: 'A React Native app connected to Odoo for sales, attendance, and inventory updates.',
        fullDescription: 'Cross-platform mobile application built with React Native that provides field teams access to Odoo data. Sales representatives can manage leads, attendance, and inventory on the go with offline support.',
        detailedContent: 'The app syncs seamlessly with Odoo servers, allows offline work, and automatically uploads changes when connectivity returns. Includes biometric attendance, GPS tracking, and real-time notifications.',
        client: 'B2B Sales Organization',
        services: 'Mobile App Development',
        completedDate: '30-11-2024',
        location: 'Pune, India',
        requirements: [
            'Cross-platform (iOS & Android)',
            'Real-time Odoo sync',
            'Offline functionality',
            'Biometric authentication',
            'GPS location tracking',
            'Push notifications'
        ],
        solution: 'Built React Native app with custom Odoo API connectors, implemented offline SQLite database, added biometric login, and integrated Google Maps for territory tracking.',
        results: 'Increased field team productivity by 45%, reduced data entry errors by 60%, improved customer response time by 50%, and achieved 99.2% app uptime.'
    },
    {
        Id: '6',
        pImg: pImg6,
        videoId: 'nbso3NVz3p8',
        icon: icon2,
        title: 'Live stock dashboard for Odoo',
        slug: 'live-stock-dashboard-for-odoo',
        rnumber: '780',
        rtext: 'Stockout reduction',
        tnumber: '150',
        ttext: 'Hours saved yearly',
        snumber: '990',
        stext: 'Accuracy improved',
        rtext1: 'Dashboard',
        rtext2: 'API',
        rtext3: 'Reports',
        description: 'A real-time stock dashboard showing inventory, valuation, and warehouse activity.',
        fullDescription: 'Real-time dashboard providing live visibility into inventory across all warehouses. Displays stock levels, valuation, movement trends, and predictive analytics for stock replenishment.',
        detailedContent: 'The dashboard uses Odoo ORM and custom Python scripts to fetch and cache data efficiently. Updates happen every minute with color-coded alerts for low stock, overstock, and slow-moving items.',
        client: 'Multi-warehouse Distribution Center',
        services: 'Dashboard Development',
        completedDate: '18-06-2024',
        location: 'Chennai, India',
        requirements: [
            'Real-time inventory visibility',
            'Multi-warehouse support',
            'Stock valuation tracking',
            'Low-stock alerts',
            'Custom report generation',
            'Mobile responsive design'
        ],
        solution: 'Developed custom Odoo module with JavaScript frontend, real-time data refresh, integrated with warehouse management system APIs, and set up automated alerts.',
        results: 'Reduced stockouts by 78%, improved inventory accuracy to 99.5%, decreased holding costs by 25%, and enabled faster replenishment decisions.'
    },
    {
        Id: '7',
        pImg: pImg7,
        videoId: 'nbso3NVz3p8',
        icon: icon3,
        title: 'Simple Odoo time tracker',
        slug: 'simple-odoo-time-tracker',
        rnumber: '950',
        rtext: 'Time tracking accuracy',
        tnumber: '500',
        ttext: 'Hours saved yearly',
        snumber: '980',
        stext: 'Entry completion',
        rtext1: 'Odoo HR',
        rtext2: 'Flow',
        rtext3: 'UI',
        description: 'A clean Odoo time tracking module for employee tasks and productivity.',
        fullDescription: 'Clean and intuitive time tracking module for Odoo that enables employees to log time against projects and tasks. Managers can track productivity and generate payroll automatically.',
        detailedContent: 'Simple interface allows employees to start/stop timers, add manual entries, and categorize work. Integrates with HR and project modules for seamless payroll and project costing.',
        client: 'Software Development Company',
        services: 'Odoo HR Module Customization',
        completedDate: '12-05-2024',
        location: 'Bangalore, India',
        requirements: [
            'Time tracking with start/stop timers',
            'Project and task integration',
            'Timesheet approval workflow',
            'Payroll integration',
            'Attendance synchronization',
            'Mobile app support'
        ],
        solution: 'Customized Odoo HR module with enhanced time tracking UI, integrated with Projects and Payroll, added mobile web interface, and set up automated payroll calculations.',
        results: 'Improved time tracking accuracy to 95%, reduced payroll processing time by 60%, increased time entry completeness from 70% to 98%, and saved 50 hours monthly in HR admin work.'
    },
    {
        Id: '8',
        pImg: pImg8,
        videoId: 'nbso3NVz3p8',
        icon: icon2,
        title: 'Magento sync with Odoo',
        slug: 'magento-sync-with-odoo',
        rnumber: '998',
        rtext: 'Order sync accuracy',
        tnumber: '700',
        ttext: 'Hours saved yearly',
        snumber: '700',
        stext: 'Processing time reduced',
        rtext1: 'Magento',
        rtext2: 'Sync',
        rtext3: 'API',
        description: 'Magento integrated with Odoo for auto orders, stock, and catalog updates.',
        fullDescription: 'Seamless integration between Magento 2 e-commerce platform and Odoo ERP for real-time order and inventory synchronization. Enables single-view of customer and product data.',
        detailedContent: 'Custom middleware synchronizes products, customers, and orders bidirectionally. Magento pricing and catalog updates from Odoo, while orders and customers sync from Magento to Odoo automatically.',
        client: 'Multi-brand E-commerce Platform',
        services: 'Magento-Odoo Integration',
        completedDate: '25-04-2024',
        location: 'Jaipur, India',
        requirements: [
            'Product catalog sync (Magento to Odoo)',
            'Real-time order transfer',
            'Inventory sync bidirectional',
            'Customer data consolidation',
            'Payment reconciliation',
            'Order status updates'
        ],
        solution: 'Built custom integration using Magento APIs and Odoo connectors, established message queue for real-time sync, created comprehensive mapping configurations, and implemented error handling.',
        results: 'Achieved 99.8% order sync accuracy, reduced order processing time by 70%, eliminated manual data entry, and handled 10,000+ orders daily without errors.'
    },
    {
        Id: '9',
        pImg: pImg2,
        videoId: 'nbso3NVz3p8',
        icon: icon2,
        title: 'Shopify–Odoo workflow automation',
        slug: 'shopify-odoo-workflow-automation',
        rnumber: '950',
        rtext: 'Workflow automation',
        tnumber: '1000',
        ttext: 'Hours saved yearly',
        snumber: '480',
        stext: 'Customer satisfaction',
        rtext1: 'Shopify',
        rtext2: 'Auto',
        rtext3: 'Sync',
        description: 'Automated returns, cancellations, and inventory sync between Shopify and Odoo.',
        fullDescription: 'Advanced workflow automation handling complex e-commerce operations including returns, cancellations, refunds, and inventory adjustments. All workflows execute automatically between Shopify and Odoo.',
        detailedContent: 'Handles edge cases like partial refunds, inventory disputes, and customer claims. Rules engine processes complex scenarios intelligently. Provides comprehensive audit logs and compliance reporting.',
        client: 'Fashion E-commerce Brand',
        services: 'Workflow Automation',
        completedDate: '08-03-2024',
        location: 'Gurgaon, India',
        requirements: [
            'Automated returns processing',
            'Cancellation workflow automation',
            'Refund reconciliation',
            'Inventory adjustment automation',
            'Customer notification workflow',
            'Dispute resolution automation'
        ],
        solution: 'Built Python-based rules engine, created workflow templates, integrated Shopify webhooks, connected Odoo processes, implemented retry logic, and set up comprehensive logging.',
        results: 'Reduced return processing time from 3 days to 2 hours, automated 95% of workflows, improved customer satisfaction to 4.8/5 stars, and saved 100+ hours monthly in manual processing.'
    },
]

export default Project;
